import React from 'react';
import { Modal, Spin } from 'antd';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import Box from '../shared/components/basic/Box';
import { setVisible } from '../../state/actions/creators/trazadora.actioncreator';
import { Flex } from '../shared/components';

export const TRAZADORA_INICIAR_DATOS_ACTION = 'iniciar_datos';
export const IFRAME_CARGADO = 'iframe_cargado';
export const TRAZADORA_GUARDAR_ACTION = 'guardar';
export const TRAZADORA_CANCELAR_ACTION = 'cancelar';
export const DATOS_CARGADOS = 'datos_cargados';

class VentanaTrazadora extends React.Component {
  constructor(props) {
    super(props);
    this.iframeParent = React.createRef();
    this.iframe = React.createRef();
    window.addEventListener('message', e => this.handleMessage(e), false);
    this.state = { loading: true };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const { trazadora: { datosVentana, visible } } = nextProps;
    if (visible) {
      const iframe = document.getElementById('iframe');
      if (iframe) iframe.src = iframe.src;
      this.setState({ loading: true });
      this.postMessage(datosVentana, TRAZADORA_INICIAR_DATOS_ACTION);
    }
  }

  shouldComponentUpdate(nextProps, nextState, nextContext) {
    return nextProps.trazadora.visible !== this.props.trazadora.visible || nextState.loading !== this.state.loading;
  }

  handleOk = (e) => {
    console.log(e);
  };

  handleCancel = (e) => {
    console.log(e);
    const { setVisible } = this.props;
    setVisible(false);
  };

  handleMessage = (e) => {
    try {
      const iframeMessage = JSON.parse(e.data);
      const { trazadora: { datosVentana } } = this.props;
      const { origin } = iframeMessage;
      const { action } = iframeMessage;
      if (origin === 'deipe.trazadora' && !!datosVentana) {
        const { data: iframeData } = iframeMessage;
        switch (action) {
          case IFRAME_CARGADO:
            this.postMessage(datosVentana, TRAZADORA_INICIAR_DATOS_ACTION);
            this.setState({ loading: true });
            break;
          case TRAZADORA_GUARDAR_ACTION:
            const data = JSON.parse(iframeData);
            const tracerData = data.shape;
            const suplementos = JSON.parse(tracerData).SHAPE_DATA.SuplementosI;
            // const formatedData = this.formatearDatosDeTrazadora(lentes, graduacionOriginal, supls, suplementos, tracerData);
            this.onGuardarHandler(suplementos, tracerData);
            break;
          case DATOS_CARGADOS:
            this.setState({ loading: false });
            break;
          case TRAZADORA_CANCELAR_ACTION:
          default:
            this.handleCancel();
            break;
        }
      }
    } catch (e) {

    }
  };

  onGuardarHandler(suplementos, tracerData) {
    const { onGuardarSuplementos } = this.props;
    onGuardarSuplementos({ suplementos, tracerData });
    this.handleCancel();
  }

  postMessage(data, action) {
    const iframe = document.getElementById('iframe');
    if (!iframe) return;
    iframe.contentWindow.postMessage(JSON.stringify({
      origin: 'deipe.gioweb2',
      action,
      data,
    }), '*');
  }

  render() {
    const { trazadora: { visible } } = this.props;
    const { loading } = this.state;
    return (
      <div>
        <style>
          {`
          .ant-modal-body{
            padding:0;
          }`
          }
        </style>
        <Modal
          title="Ventana Biselado"
          visible={visible}
          onOk={this.handleOk}
          onCancel={this.handleCancel}
          width={1180}
          footer={null}
        >
          <Box ref={this.iframeParent} width={1180} height={570}>
            <iframe
              style={loading ? { display: 'none' } : {}}
              ref={this.iframe}
              height="100%"
              width="100%"
              frameBorder="0"
              scrolling="no"
              id="iframe"
              src={window.GIO_CONFIG.BISELADORA_URL}
              title="Biselado"
            />
            {loading && <Flex justifyContent="center" alignItems="center" height="100%"><Spin tip="Cargando datos" /></Flex>}
          </Box>
        </Modal>
      </div>
    );
  }
}
VentanaTrazadora.defaultProps = {
};

VentanaTrazadora.propTypes = {
  trazadora: PropTypes.shape({
    visible: PropTypes.bool,
    datosVentana: PropTypes.shape({}),
  }).isRequired,
  setVisible: PropTypes.func.isRequired,
  onGuardarSuplementos: PropTypes.func.isRequired,
};


const mapStateToProps = ({ trazadora }) => ({
  trazadora,
});
function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    setVisible,
  }, dispatch);
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(VentanaTrazadora));
